export default __webpack_public_path__ + "static/media/lease.4d99c8f3.svg";